import { defineStore } from 'pinia';
import MetaCampaignsCampaignsAPI from 'dashboard/api/metaCampaignsCampaigns';

export const useMetaCampaignsCampaignsStore = defineStore(
  'metaCampaignsCampaigns',
  {
    state: () => ({
      records: [],
      selectedCampaign: null,
      uiFlags: {
        fetchingList: false,
        fetchingItem: false,
      },
    }),

    getters: {
      getCampaigns: state => state.records,
      getSelectedCampaign: state => state.selectedCampaign,
    },

    actions: {
      async fetch(params = {}) {
        this.uiFlags.fetchingList = true;
        try {
          const { data } = await MetaCampaignsCampaignsAPI.get(params);
          this.records = data;
        } finally {
          this.uiFlags.fetchingList = false;
        }
      },

      async fetchOne(id, params = {}) {
        this.uiFlags.fetchingItem = true;
        try {
          const { data } = await MetaCampaignsCampaignsAPI.show(id, params);
          this.selectedCampaign = data;
        } finally {
          this.uiFlags.fetchingItem = false;
        }
      },
    },
  }
);
